import { useMutation } from "react-query";
import { put } from "../../../../http";
import { savedExortSettings } from "../../bulkBaseUrl";
import { IBulkSavedExistExportSettingsMutationPayload } from "./saveExistBulkExportState.types";

export function useSaveExistBulkExportStateMutation() {
  const { isLoading, isError, isSuccess, mutate } = useMutation((payload: IBulkSavedExistExportSettingsMutationPayload) =>
  saveExistBulkExportState(payload)
  );
  return { isSaveExistBulkExportStateLoading: isLoading, isSaveExistBulkExportStateError: isError, isSaveExistBulkExportStateSuccess: isSuccess, saveExistBulkExportState: mutate };
}

async function saveExistBulkExportState(payload: IBulkSavedExistExportSettingsMutationPayload) {
  try {
    
    const url = savedExortSettings + `/${payload.id}`;
    
    await put(url,payload.data, {
      headers: {
        Accept: "*/*",
      },
    });
  } catch (err) {
    console.error(err);
  }
}
